import { useIsLoggedInQuery } from 'auth/hooks'
import { useUserAuthModal } from '@repo/user-auth-dialog/user-auth-dialog-context'
import * as React from 'react'

export function useLoggedInAction<T extends unknown[]>(
  loggedInAction?: (...args: T) => Promise<void> | void,
) {
  const { data: isLoggedIn } = useIsLoggedInQuery()
  const loginModal = useUserAuthModal()

  const tryExecuteLoggedInAction = React.useCallback(
    async (...args: T): Promise<void> => {
      if (!isLoggedIn) {
        loginModal.openModal()
        return
      }
      await loggedInAction?.(...args)
    },
    [isLoggedIn, loginModal, loggedInAction],
  )

  return { tryExecuteLoggedInAction }
}
